import Vue from "vue";

import "@/assets/styles/quasar.styl";
import "@/assets/styles/newColors.scss";
import "quasar/dist/quasar.ie.polyfills";
import "quasar/dist/quasar.styl";

import "@quasar/extras/roboto-font/roboto-font.css";
import "@quasar/extras/mdi-v4/mdi-v4.css";
import "@quasar/extras/material-icons/material-icons.css";
import "@/assets/styles/iconsax/style.css";

import Quasar, * as all from "quasar";

import "@/assets/styles/common.scss";
import { allowAccessibilityColors } from "@/assets/js/appFunc";

const components = {};
const directives = {};
const plugins = {};

Object.keys(all).forEach(entry => {
    if (/[A-Z]/.test(entry[0])) {
        const doImport = all[entry];
        if (typeof doImport === "function") {
            components[entry] = doImport;
        } else {
            const { install } = doImport;
            if (typeof install === "function") {
                plugins[entry] = doImport;
            } else {
                const { name, unbind } = doImport;
                if (name !== undefined && unbind !== undefined) {
                    directives[entry] = doImport;
                }
            }
        }
    }
});

Vue.use(Quasar, {
    config: {
    },
    components,
    directives,
    plugins
});
const hasAccessibility = localStorage.getItem("accessibility");
const hasAccFeature = localStorage.getItem("accessibilityFeature");

allowAccessibilityColors(hasAccessibility === "true" && hasAccFeature === "true");

Vue.config.productionTip = false;
